import request from '@/utils/request'

// 初始化数据
export function initData(pageName) {
  return request({
    url: 'admin/prj/quickcondition/init/' + pageName,
    method: 'get'
  })
}

// 快速条件
export function getCondition(id) {
  return request({
    url: 'admin/prj/quickcondition/getCondition/' + id,
    method: 'get'
  })
}

// 删除
export function delCondition(id) {
  return request({
    url: 'admin/prj/quickcondition/delCondition/' + id,
    method: 'get'
  })
}

// 保存
export function saveData(data) {
  return request({
    url: 'admin/prj/quickcondition/save',
    method: 'post',
    data: data
  })
}